import React from "react";
import style from "./index.module.scss";
const FilterSearch = ({ onChange, onSubmit }) => {
  return (
    <div className={style.FilterSearch}>
      <div className={style.Search}>
        <input
          // id={id}
          onChange={onChange}
          className={style.InputSearch}
          type="text"
          placeholder="Tìm kiếm theo tên, số điện thoại, công ty"
          autoComplete="off"
        />
        <div className={style.IconSearch}>
          <img src="icon_search.svg" width={20} height={20} alt="logo" />
        </div>
      </div>
      <div>
        <button className={style.btnSubmit} onClick={onSubmit} >Tìm kiếm</button>
      </div>
    </div>
  );
};

export default FilterSearch;
